import { getPartnersPartnerIdScore } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const PARTNER_SCORE = "PARTNER_SCORE";

export function usePartnerScore(partnerId?: number) {
	return useQuery({
		queryKey: [PARTNER_SCORE, partnerId],
		queryFn: processResponse(() => getPartnersPartnerIdScore(partnerId!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!partnerId,
	});
}
